import React from 'react';
import { connect } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function BeforeCallWaitingArea(props) {
  let rightPanel = {};
  let centerPanel = {};
  let title = undefined;
  let subtitle = undefined;
  let trimmedGroup = {};
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';
  rightPanel = (
    <RightPanelTop
      waitingArea={props.waitingArea}
      beforeCallsForm={props.beforeCallsForm}
      updateOrView={props.updateOrView}
    />
  );
  centerPanel = (
    <CenterPanel
      beforeCallsForm={props.beforeCallsForm}
      waitingArea={props.waitingArea}
      updateOrView={props.updateOrView}
    />
  );
  title = `${APP.LANGUAGE.WaitingAreaBeforeCallsCallers.TitleUpdateAndView} ${APP.LANGUAGE.WaitingAreaBeforeCallsCallers.TitleBracketPart}`;
  subtitle = updatingWaitingAreaName;

  return (
    <Modal show={props.showBeforeCallsModal} hideWhenClickAway={false}>
      <PopupHeader helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpBeforeCalls} title={title} subtitle={subtitle} />
      <div className="content before-calls-modal">
        <div className="main-ui-container before-calls-modal">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
